import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import axios from 'src/app/Service/axios';
import momentJalaali from 'moment-jalaali';

declare let $: any

@Component({

  selector: 'app-school-contracts',

  templateUrl: './school-contracts.component.html',

  styleUrls: ['./school-contracts.component.css']

})

export class SchoolContractsComponent implements OnInit {

  bEditMod: boolean = false;

  bViewMod: boolean = false;

  acssess: any;

  lst_Result = [];

  lst_Search = [];

  lst_ContractStatus = [];

  lst_GroupCar = [];

  mdl_Search: FormGroup = this.FormBuilder.group({

    iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    strNationalCode: new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]),

  })

  mdl_Save: FormGroup = this.FormBuilder.group({

    iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    strPassenger_FullName: new FormControl(''),

    strMobile: new FormControl(''),

    iMadonik_ServiceContract: new FormControl(''),

    strMobileDomain_strComment: new FormControl(''),

    iPassenger: new FormControl(''),

    strContactNo: new FormControl('2'),

    tiMobileType: new FormControl('', Validators.required),

    strSDate: new FormControl('1404/07/01', Validators.required),

    strEDate: new FormControl('1405/03/31', Validators.required),

    tiMadonik_ContractStatus: new FormControl('', Validators.required),

    iContractAmount: new FormControl('1000', Validators.required),

    strPaymentTerms: new FormControl(''),

    iAmountPaid: new FormControl('1000'),

    strDetail: new FormControl('تست است'),

    index: new FormControl(''),

  })

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private route: ActivatedRoute,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

  ) { }

  ngOnInit(): void {

    var data = window.localStorage.getItem("menu") as any;

    this.acssess = JSON.parse(this.gurdService.decrypt(data));

    this.getContract_List();

    this.getInitializeData()

  }

  getContract_List = async () => {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`Madonik_ServiceContract_List`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.ISSessionExpired == true) {

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: '1xxA4' } });

      return;

    }

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Result = res;

    this.lst_Search = res;


  }

  getInitializeData = async () => {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`Madonik_ContractStatus_List`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.ISSessionExpired == true) {

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: '1xxA4' } });

      return;

    }

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_ContractStatus = res;

    // ---------------------------------------------------------------------------

    let response = await axios.post(`GetMobileType`, {});

    this.lst_GroupCar = response.data;


  }

  openModal() {

    this.mdl_Search.patchValue({

      strNationalCode: ''

    })

    this.mdl_Save.patchValue({

      iPassenger: '',

      strPassenger_FullName: '',

      strMobile: '',

      strMobileDomain_strComment: '',

      strName: '',

      strContactNo: '',

      tiMobileType: '',

      strSDate: `${momentJalaali().jYear()}/07/01`,

      strEDate: `${momentJalaali().jYear() + 1}/03/31`,

      tiMadonik_ContractStatus: '',

      iContractAmount: 0,

      strPaymentTerms: '',

      iAmountPaid: '0',

      strDetail: '',

    })

    this.bEditMod = false;

    this.bViewMod = false;

    this.mdl_Save.enable();

    $("#AddOrEdit_Modal").modal('show')

  }

  openEditModal(item, index: number) {

    Object.keys(item).forEach(key => {

      this.mdl_Save.get(key)?.setValue(item[key])

    })

    this.mdl_Save.patchValue({

      iContractAmount: item.iContractAmount.toLocaleString(),

      iAmountPaid: item.iAmountPaid.toLocaleString(),

      index: index

    })

    this.bEditMod = true;

    this.bViewMod = false;

    this.mdl_Save.enable();

    $("#AddOrEdit_Modal").modal('show')


  }

  openViewModal(item, index: number) {

    Object.keys(item).forEach(key => {

      this.mdl_Save.get(key)?.setValue(item[key])

    })

    this.mdl_Save.patchValue({

      iContractAmount: item.iContractAmount.toLocaleString(),

      iAmountPaid: item.iAmountPaid.toLocaleString(),

      index: index

    })

    this.mdl_Save.disable();

    this.bViewMod = true;

    $("#AddOrEdit_Modal").modal('show');


  }

  searchStudent = async () => {

    if (this.mdl_Search.invalid) return this._tooltip.showError('کد ملی را به درستی وارد کنید!')

    this._otherService.Showspinner();

    let model = this._otherService.stringNumberToNumber(this.mdl_Search.value);

    let res = JSON.parse((await axios.post(`Passenger_SearchBystrNationID`, model)).data.toString());

    this._otherService.nonespinner();

    if (res.ISSessionExpired == true) {

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: '1xxA4' } });

      return;

    }

    if (res.iResult == 0) {

      this._tooltip.showError(res.strError);

      this.mdl_Save.patchValue({

        iPassenger: '0',

        strName: '',

        strPassenger_FullName: '',

        strMobile: '',

        strMobileDomain_strComment: '',

      })

    }

    else {

      this.mdl_Save.patchValue({

        iPassenger: res[0].iPassenger,

        strPassenger_FullName: res[0].strPassenger_FullName,

        strMobile: res[0].strMobile,

        strMobileDomain_strComment: res[0].strMobileDomain_strComment,

      })


    }

  }

  onSubmit_Student(event) {

    if (event.length) {

      this.mdl_Save.patchValue({

        iPassenger: event[0].iPassenger,

        strPassenger_FullName: event[0].strPassenger_FullName,

        strMobile: event[0].strMobile,

        strMobileDomain_strComment: event[0].strMobileDomain_strComment,

      })

    }


  }

  submitRequest = async () => {

    if (this.mdl_Save.invalid) return this._tooltip.showError('فرم را با دقت تکمیل کنید!')

    let model = this._otherService.stringNumberToNumber(this.mdl_Save.value);

    if (this.bEditMod) {

      $.confirm({

        title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,

        content: '',

        type: 'blue',

        buttons: {

          ok: {

            text: "ویرایش",

            btnClass: 'btn-primary',

            keys: ['enter'],

            action: async () => {

              this._otherService.Showspinner();

              let res = JSON.parse((await axios.post(`Madonik_ServiceContract_Edit`, model)).data.toString());

              this._otherService.nonespinner();

              if (res.ISSessionExpired == true) {

                this._otherService.removeLocalStorage();

                this.router.navigate(['login'], { queryParams: { error: '1xxA4' } });

                return;

              }

              if (res.iResult == 0) return this._tooltip.showError(res.strError);

              this.lst_Result[this.mdl_Save.get('index')?.value] = res[0];

              this.lst_Search = this.lst_Result;

              this._tooltip.showSuccess('با موفقیت ویرایش شد.');

              $("#AddOrEdit_Modal").modal('hide');


            }

          },

          cancel: {

            text: "لغو",

          }

        }

      });

    }

    else {

      this._otherService.Showspinner();

      let res = JSON.parse((await axios.post(`Madonik_ServiceContract_Save`, model)).data.toString());

      this._otherService.nonespinner();

      if (res.ISSessionExpired == true) {

        this._otherService.removeLocalStorage();

        this.router.navigate(['login'], { queryParams: { error: '1xxA4' } });

        return;

      }

      if (res.iResult == 0) return this._tooltip.showError(res.strError);

      this.lst_Result.push(res[0]);

      this.lst_Search = this.lst_Result;

      this._tooltip.showSuccess('با موفقیت ثبت شد.');

      $("#AddOrEdit_Modal").modal('hide');

    }

  }

  removeItem(item, index) {

    $.confirm({

      title: `آیا از حذف اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            this._otherService.Showspinner()

            var model = {

              iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

              strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

              iMadonik_ServiceContract: item.iMadonik_ServiceContract
            }

            let res = JSON.parse((await axios.post(`Madonik_ServiceContract_Delete`, this._otherService.stringNumberToNumber(model))).data.toString());

            this._otherService.nonespinner()

            if (res.iResult == 0) return this._tooltip.showError(res.strError);

            else {

              this.lst_Result.splice(index, 1);

              this._tooltip.showSuccess(' با موفقیت حذف شد');

            }


          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });
  }

  filter_list(val: any) {

    this.lst_Result = this.lst_Search.filter((el: any) => {

      return el?.strDate?.startsWith(val.value)

        || el?.strMobileDomain_strComment?.startsWith(val.value)

        || el?.strPassenger_FullName?.startsWith(val.value)

        || el?.strMobile?.startsWith(val.value)

        || el?.strMadonik_ContractStatus_strComment?.startsWith(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_Result = this.lst_Search;

    }


  }

  accessibility(...array: string[]): boolean {

    // return true;

    let result = false;

    for (let i = 0; i < array.length; i++) {

      if (this.acssess[array[i]] == true && !result) {

        result = true;

        break;

      }

    }

    return result;

  }

}
